const consts = {
    default_route: '/units',
    fetchAppProps: {
        dispatches: [
            {name: 'fetchUserSettings', params: {}},
            {name: 'fetchUnitsIcons', params: {}},
            {name: 'fetchUserFavoritesAndObjects', params: {}},
            {name: 'fetchUnitsHwTypesAll', params: {}},
            {name: 'fetchUnitsHwTypesSettings', params: {}},
            {name: 'fetchUnitsTypes', params: {}},
            //{name: 'fetchUnitsXTypes', params: {}},
            {name: 'fetchGrafanaSettings', params: {}},

            {name: 'fetchAppUser', params: {}},

            {name: 'fetchAppObjects', params: [
                {name: 'fetchUnitsLmsgsAll', params: {withAddress: 1, withSensors: 1}},
                {name: 'fetchVideoStatusesAll', params: {}},
                {name: 'fetchUnitsAll', params: {}},

                {name: 'fetchUsersAll', params: {}},
                //{name: 'fetchUsersCustomizesAll', params: {}},

                {name: 'fetchGeopointsAll', params: {}},
                {name: 'fetchGeozonesAll', params: {}},
                // {name: 'fetchNotificationsAll', params: {}},
            ]},

            //{name: 'fetchNotificationsAll', params: {}},
            {name: 'fetchNotificationsAll', params: {'filter[special]': 'system'}},

            //{name: 'fetchEvents4Date', params: {date: 'today', withAddress: 1}},
            //{name: 'fetchVideoEvents4Date', params: {date: 'today', withAddress: 1}},
            //{name: 'fetchNotificationsEvents4Date', params: {date: 'today', withAddress: 1}},
            //{name: 'fetchVideoRequests4Date', params: {date: 'today', withAddress: 1}},
        ],
    },
    reloadAppProps: {
        dispatches: [
            {name: 'reloadUnitsAll', params: {}},
            {name: 'reloadUnitsLmsgsAll', params: {withAddress: 1}},
            {name: 'reloadVideoStatusesAll', params: {}},

            // {name: 'reloadUsersAll', params: {}},
            //{name: 'reloadUsersCustomizesAll', params: {}},

            // {name: 'reloadGeopointsAll', params: {}},
            // {name: 'reloadGeozonesAll', params: {}},

            {name: 'reloadNotificationsAll', params: {}},

            // {name: 'reloadEvents', params: {withAddress: 1}},
            // {name: 'reloadVideoEvents', params: {withAddress: 1}},
            // {name: 'reloadNotificationsEvents', params: {withAddress: 1}},
        ],
        commits: [
            {name: 'clearTrips', params: {}},
            {name: 'clearParkings', params: {}},
            {name: 'clearTracks', params: {}},

            {name: 'clearEvents', params: {}},
            {name: 'clearVideoEvents', params: {}},
            {name: 'clearNotificationsEvents', params: {}},
            {name: 'clearStops', params: {}},

            {name: 'clearVideoRequests', params: {}},
            {name: 'clearVideoRecords', params: {}},
        ],
    },
    fetchByTimer: {
        dispatches: [
            //{name: 'fetchAppUserChanged', eachT: 30, params: {}},

            {name: 'fetchUnitsChanged', eachT: 30, params: {}},
            {name: 'fetchUnitsLmsgsChanged', eachT: 15, params: {withAddress: 1, withSensors: 1}},//'filter[changed]': 60,
            {name: 'fetchVideoStatusesChanged', eachT: 30, params: {}},

            {name: 'fetchUsersChanged', eachT: 30, params: {}},
            {name: 'fetchUserFavoritesAndObjects', eachT: 30, params: {}},
            //{name: 'fetchUsersCustomizesChanged', eachT: 30, params: {}},

            {name: 'fetchGeopointsChanged', eachT: 30, params: {}},
            {name: 'fetchGeozonesChanged', eachT: 30, params: {}},

            //{name: 'fetchNotificationsChanged', eachT: 30, params: {}},
            {name: 'fetchNotificationsChanged', eachT: 30, params: {'filter[special]': 'system'}},

            //{name: 'fetchEventsChanged', eachT: 30, params: {withAddress: 1}},
            //{name: 'fetchLastEvents', eachT: 30, params: {last: '15 minutes', withAddress: 1}},
            //{name: 'fetchLastVideoEvents', eachT: 30, params: {last: '15 minutes', withAddress: 1}},
            //{name: 'fetchLastNotificationsEvents', eachT: 30, params: {last: '15 minutes', withAddress: 1}},

            //{name: 'fetchVideoRequestsChanged', eachT: 30, params: {withAddress: 1}},
        ],
    },
    api: {
        user: {
            //fields: [],
            expand: ['units_of_measure','settings','notifications_settings','is_admin','is_super_admin', 'limited','parents','dealer_apikeys','hide_menu','dealers_hide_menu','head__logo','dealer_login_logo', 'map_apikeys', 'shifts'],
        },

        unit: {
            fields: ['id',],
            //expand: ['ext-services'],
        },
        units_lite: {
            fields: ['id','hw_type','hw_id','name','isRemoved','icon','icon_color','icon_static','parent__id'],//,'icon_halo'
            expand: [], //'access_right','user_creator', counters
        },
        units: {
            //fields: ['id','hw_type','hw_id','name','type','unit_icon','icon','max_speed','phone'],
            expand: ['user_creator','access_right', 'tags', 'cameras'], //,counters ,'video'
        },

        users_lite: {
            //fields: [],
            expand: ['user_creator', 'is_admin', 'limited', 'access_right'],
        },
        users: {
            //fields: ['id','creator','login','email','phone','legal_name','time_zone','dst','status'],
            expand: ['user_creator', 'is_admin', 'limited', 'access_right'],
        },

        geopoints_lite: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right'], //'points'
        },
        geopoints: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right'], //'points'
        },
        geozones_lite: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right'], //'points'
        },
        geozones: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right','points'], //'points'
        },

        notifications: {
            //fields: [],
            expand: ['units','units-groups','geozones','geopoints'],
        },
        notifications_lite: {
            fields: [],
            expand: ['units','units-groups','geozones','geopoints'],
        },

        shipments: {
            //fields: [],
            expand: ['report', 'shippingTime', 'shipping__time', 'deliveryTime', 'delivery__time', 'started__time', 'completed__time', 'manual_started__time', 'manual_completed__time', 'arrival__time', 'departure__time', 'actual_arrival__time', 'actual_departure__time'],
        },
        shipmentsPackages: {
            //fields: [],
            expand: ['shippingTime', 'shipping__time', 'deliveryTime', 'delivery__time', 'started__time', 'completed__time'],
        },
        shipmentsTracks: {
            //fields: [],
            expand: [],
        },

        units_msgs: {
            // fields: ['id',],
            expand: [],
        },

        events: {
            //fields: [],
            expand: [],
        },
        events_lite: {
            //fields: [],
            expand: [],
        },
        video_events: {
            //fields: [],
            expand: [],
        },
        video_events_lite: {
            //fields: [],
            expand: [],
        },
        video_requests: {
            //fields: [],
            expand: ['image'],
        },
        accidents: {
            //fields: [],
            expand: ['image'],
        },
        video_requests_lite: {
            //fields: [],
            expand: [],
        },
        video_records: {
            //fields: [],
            expand: [],
        },
        video_records_lite: {
            //fields: [],
            expand: [],
        },
        locator_shipments: {
            //fields: [],
            expand: ['shipping__time', 'delivery__time', 'started__time', 'completed__time', 'creator_head__logo'],
        },
        locator_units: {
            //fields: [],
            expand: [],
        },
        reportsSchedulers: {
            //fields: [],
            expand: ['date__time'],
        }
    },
    components: {
        UnitEdit: {
            defaults: {
                options: {
                    components: [
                        'UnitEdit_Options_intuit',
                        'UnitEdit_Icon_intuit',
                        'UnitEdit_AddInfo_intuit',
                        'UnitEdit_Sensors_intuit',
                    ]
                }
            },
            xCargoUnit: {
                options: {
                    components: [
                        'UnitEdit_Options_intuit',
                        'UnitEdit_Delivery',
                        'UnitEdit_xCargoSensors',
                    ]
                }
            }
        },
        ShipmentEdit:{
            defaults: {
                options: {
                    components: [
                        'ShipmentEdit_Options',
                    ]
                }
            },
        },
        ShipmentEditGroup:{
            defaults: {
                options: {
                    components: [
                        'ShipmentEditGroup_Options',
                    ]
                }
            },
        }
    },
    unitHwTypeTransformationToRoute: {
        xcargo: {
            template: 'xgrafana',
        },
        xcargo_m2m: {
            template: 'xgrafana',
        },
        xcargo_m2m_oneway: {
            template: 'xgrafana',
        },
        m2m: {
            template: 'xgrafana',
        },
        tive: {
            template: 'xgrafana',
        },
        pro_cargo_vision: {
            template: 'pro_cargo_vision',
        },//???
    },
    unitTypeTransformationToRoute: {
    },
    timelineComponentByRouteTemplate: {
        pro_cargo_vision: 'TimelineWrap_pro_cargo_vision',
        xbles: 'TimelineWrap_xbles',
        xcool: 'TimelineWrap_xcool',
        m2m: 'TimelineWrap_M2M',
        m2m_chassis: 'TimelineWrap_M2M',
    }
}

export default consts